// @ts-nocheck

export const localeCodes =  [
  "pt",
  "en",
  "es",
  "it"
]
export const localeLoaders = {
  pt: [
    {
      key: "locale_pt_BR_46json_617510a5",
      load: () => import("#nuxt-i18n/617510a5" /* webpackChunkName: "locale_pt_BR_46json_617510a5" */),
      cache: true
    },
    {
      key: "locale_pt_BR_46json_9a0247bd",
      load: () => import("#nuxt-i18n/9a0247bd" /* webpackChunkName: "locale_pt_BR_46json_9a0247bd" */),
      cache: true
    },
    {
      key: "locale_pt_BR_46json_2e0b7be7",
      load: () => import("#nuxt-i18n/2e0b7be7" /* webpackChunkName: "locale_pt_BR_46json_2e0b7be7" */),
      cache: true
    },
    {
      key: "locale_pt_BR_46json_e71b4886",
      load: () => import("#nuxt-i18n/e71b4886" /* webpackChunkName: "locale_pt_BR_46json_e71b4886" */),
      cache: true
    },
    {
      key: "locale_pt_BR_46json_0d3ed03d",
      load: () => import("#nuxt-i18n/0d3ed03d" /* webpackChunkName: "locale_pt_BR_46json_0d3ed03d" */),
      cache: true
    },
    {
      key: "locale_pt_BR_46json_f02f17b8",
      load: () => import("#nuxt-i18n/f02f17b8" /* webpackChunkName: "locale_pt_BR_46json_f02f17b8" */),
      cache: true
    },
    {
      key: "locale_pt_BR_46json_1716642e",
      load: () => import("#nuxt-i18n/1716642e" /* webpackChunkName: "locale_pt_BR_46json_1716642e" */),
      cache: true
    },
    {
      key: "locale_pt_BR_46json_736c30cc",
      load: () => import("#nuxt-i18n/736c30cc" /* webpackChunkName: "locale_pt_BR_46json_736c30cc" */),
      cache: true
    },
    {
      key: "locale_pt_BR_46json_494b2b93",
      load: () => import("#nuxt-i18n/494b2b93" /* webpackChunkName: "locale_pt_BR_46json_494b2b93" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_5ef3bb15",
      load: () => import("#nuxt-i18n/5ef3bb15" /* webpackChunkName: "locale_en_46json_5ef3bb15" */),
      cache: true
    },
    {
      key: "locale_en_46json_20fb6258",
      load: () => import("#nuxt-i18n/20fb6258" /* webpackChunkName: "locale_en_46json_20fb6258" */),
      cache: true
    },
    {
      key: "locale_en_46json_b7a6725b",
      load: () => import("#nuxt-i18n/b7a6725b" /* webpackChunkName: "locale_en_46json_b7a6725b" */),
      cache: true
    },
    {
      key: "locale_en_46json_2d7f2c26",
      load: () => import("#nuxt-i18n/2d7f2c26" /* webpackChunkName: "locale_en_46json_2d7f2c26" */),
      cache: true
    },
    {
      key: "locale_en_46json_0f89c35a",
      load: () => import("#nuxt-i18n/0f89c35a" /* webpackChunkName: "locale_en_46json_0f89c35a" */),
      cache: true
    },
    {
      key: "locale_en_46json_509aac86",
      load: () => import("#nuxt-i18n/509aac86" /* webpackChunkName: "locale_en_46json_509aac86" */),
      cache: true
    },
    {
      key: "locale_en_46json_2842bad5",
      load: () => import("#nuxt-i18n/2842bad5" /* webpackChunkName: "locale_en_46json_2842bad5" */),
      cache: true
    },
    {
      key: "locale_en_46json_50a14a69",
      load: () => import("#nuxt-i18n/50a14a69" /* webpackChunkName: "locale_en_46json_50a14a69" */),
      cache: true
    },
    {
      key: "locale_en_46json_2c89b3ff",
      load: () => import("#nuxt-i18n/2c89b3ff" /* webpackChunkName: "locale_en_46json_2c89b3ff" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_42a98a00",
      load: () => import("#nuxt-i18n/42a98a00" /* webpackChunkName: "locale_es_46json_42a98a00" */),
      cache: true
    },
    {
      key: "locale_es_46json_6a9d1635",
      load: () => import("#nuxt-i18n/6a9d1635" /* webpackChunkName: "locale_es_46json_6a9d1635" */),
      cache: true
    },
    {
      key: "locale_es_46json_41a5aa42",
      load: () => import("#nuxt-i18n/41a5aa42" /* webpackChunkName: "locale_es_46json_41a5aa42" */),
      cache: true
    },
    {
      key: "locale_es_46json_5be06087",
      load: () => import("#nuxt-i18n/5be06087" /* webpackChunkName: "locale_es_46json_5be06087" */),
      cache: true
    },
    {
      key: "locale_es_46json_24cfc1b0",
      load: () => import("#nuxt-i18n/24cfc1b0" /* webpackChunkName: "locale_es_46json_24cfc1b0" */),
      cache: true
    },
    {
      key: "locale_es_46json_2028a926",
      load: () => import("#nuxt-i18n/2028a926" /* webpackChunkName: "locale_es_46json_2028a926" */),
      cache: true
    },
    {
      key: "locale_es_46json_2b7ec610",
      load: () => import("#nuxt-i18n/2b7ec610" /* webpackChunkName: "locale_es_46json_2b7ec610" */),
      cache: true
    },
    {
      key: "locale_es_46json_edca285f",
      load: () => import("#nuxt-i18n/edca285f" /* webpackChunkName: "locale_es_46json_edca285f" */),
      cache: true
    },
    {
      key: "locale_es_46json_5a043d44",
      load: () => import("#nuxt-i18n/5a043d44" /* webpackChunkName: "locale_es_46json_5a043d44" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_332e4db9",
      load: () => import("#nuxt-i18n/332e4db9" /* webpackChunkName: "locale_it_46json_332e4db9" */),
      cache: true
    },
    {
      key: "locale_it_46json_58545d44",
      load: () => import("#nuxt-i18n/58545d44" /* webpackChunkName: "locale_it_46json_58545d44" */),
      cache: true
    },
    {
      key: "locale_it_46json_4096255b",
      load: () => import("#nuxt-i18n/4096255b" /* webpackChunkName: "locale_it_46json_4096255b" */),
      cache: true
    },
    {
      key: "locale_it_46json_53adcc03",
      load: () => import("#nuxt-i18n/53adcc03" /* webpackChunkName: "locale_it_46json_53adcc03" */),
      cache: true
    },
    {
      key: "locale_it_46json_b69ec30d",
      load: () => import("#nuxt-i18n/b69ec30d" /* webpackChunkName: "locale_it_46json_b69ec30d" */),
      cache: true
    },
    {
      key: "locale_it_46json_3676672a",
      load: () => import("#nuxt-i18n/3676672a" /* webpackChunkName: "locale_it_46json_3676672a" */),
      cache: true
    },
    {
      key: "locale_it_46json_c67d322d",
      load: () => import("#nuxt-i18n/c67d322d" /* webpackChunkName: "locale_it_46json_c67d322d" */),
      cache: true
    },
    {
      key: "locale_it_46json_30eeaa23",
      load: () => import("#nuxt-i18n/30eeaa23" /* webpackChunkName: "locale_it_46json_30eeaa23" */),
      cache: true
    },
    {
      key: "locale_it_46json_623acada",
      load: () => import("#nuxt-i18n/623acada" /* webpackChunkName: "locale_it_46json_623acada" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "pt",
    name: "Português (Brasil)",
    language: undefined
  },
  {
    code: "en",
    name: "English",
    language: undefined
  },
  {
    code: "es",
    name: "Español",
    language: undefined
  },
  {
    code: "it",
    name: "Italiano",
    language: undefined
  }
]

